<app-admin-panel-user-organization-data-section
  sectionTitle="Pozostałe informacje"
  [fields]="fields()"
></app-admin-panel-user-organization-data-section>
